import React,{ useState, useEffect } from 'react';
import { Rate , Col, Row, Carousel } from 'antd';
import { PlusOutlined, ArrowRightOutlined  } from '@ant-design/icons';

import Star from '../../components/Star/Star'

import './Community.less'

const Community = ({communityData}) =>{
  let [renderArr, setRenderArr] = useState([])
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(()=>{
    let arr = [[],[],[],[]]

    communityData.cardList.forEach((e,i)=>{
      arr[i%4].push(e)
      arr[i%4].push(communityData.videoList[i])
    })

    console.log(arr)
    setRenderArr(()=> arr)



    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  return (
    <div className="community-box">
      <div className="community-title">Loved by our community</div>

      <Row gutter={[24,16]} justify="space-between" className="community-comment-box">
        {renderArr.map((e,i)=>{
          return (
            <Col key={i} span={width> 770? 6:24} className="community-comment-item-box">
              <div className="community-comment-item">
                {e.map((E,I)=>{

                  if(E.type === 'card'){
                    return (
                      <div key={I} className="community-card-box">
                        <div>
                          <Star score={E.star}/>
                        </div>
                        <h2 className="community-card-title">{E.title}</h2>
                        <div className="community-card-content line-clamp-5">{E.content}</div>
                        <div className="community-card-name">{E.name}</div>
                        <div className="product-box">
                          <img style={{width:40, height: 40, borderRadius: 5}} src={E.productImg} alt=""/>
                          <div className="product-name-box">
                            <div style={{color: 'rgba(0, 0, 0, 0.54)'}}>Reviewed</div>
                            <div style={{borderBottom:'1px solid #000'}}>{E.productName}</div>
                          </div>
                        </div>
                      </div>
                    )
                  }else{
                    if(E.cardType === 'doctor'){
                      return (
                        <div key={I} className="community-video-box">
                          <img src={E.img} alt="" />

                          <div className="community-video-bottom">
                            <h2>{E.name}</h2>
                            <div className="community-video-achievement">{E.achievement}</div>
                          </div>
                        </div>
                      )
                    }else{
                      return (
                        <div key={I} className="community-video-box">
                          <img src={E.img} alt="" />
                          
                          <div className="community-video-bottom">
                            <a className="community-video-userName">
                              <span>@{E.name}</span>
                            </a>
                            <div className="product-box">
                              <img style={{width:40, height: 40, borderRadius: 5}} src={E.productImg} alt=""/>
                              <div className="product-name-box">
                                <div style={{color: '#fff'}}>Reviewed</div>
                                <div style={{borderBottom:'1px solid #fff'}}>{E.productName}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  }
                })}
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}

export default Community